<template>
  <TableCell>
    <div :style="columnStyle">
      <div
        class="h-5 my-1.5 bg-gray-200 rounded-xs animate-pulse"
        :style="randomWidth"
      />
    </div>
  </TableCell>
</template>

<script setup>
import { computed } from "vue";
import { TableCell } from "@/Shadcn/Components/ui/table";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { type, maxSmall, minLarge } = useBreakpoints();

const props = defineProps({
  column: { type: Object, required: true },
  maxWidthResponsiveColumn: { type: Number, default: 200 },
});

const columnWidth = getColumnWidth();

const columnStyle = computed(() => {
  if (columnWidth) {
    return {
      width: columnWidth + "px",
    };
  }

  return { width: props.maxWidthResponsiveColumn + "px" };
});

function getColumnWidth() {
  if (!props.column.meta?.size) {
    return props.column.size;
  }

  return (
    props.column.meta.size[
      maxSmall.value
        ? "sm"
        : type.value === "2xl"
        ? "2xl"
        : minLarge.value
        ? "lg"
        : "md"
    ] || undefined
  );
}

const fixedWidthColumns = [
  "select",
  "expiration_date",
  "reminder_date",
  "public",
];

const widths = ["3.5rem", "3.75rem", "4rem", "4.25rem"];

const randomWidth = computed(() => {
  if (fixedWidthColumns.includes(props.column.id)) {
    return {
      width: `calc(100% - 2rem)`,
    };
  }

  return {
    width: `calc(100% - ${widths[Math.floor(Math.random() * widths.length)]})`,
  };
});
</script>
